/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentRenegotiationsPreview200,
  PostApiV1IndividualpaymentRenegotiationsPreview401,
  PostApiV1IndividualpaymentRenegotiationsPreview500,
  PostApiV1IndividualpaymentRenegotiationsPreviewMutationRequest,
  PostApiV1IndividualpaymentRenegotiationsPreviewMutationResponse,
} from "../../types/individualPaymentRenegotiationController/PostApiV1IndividualpaymentRenegotiationsPreview.ts";
import { individualPaymentRenegotiationViewModelSchema } from "../individualPaymentRenegotiationViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentRenegotiationsPreview200Schema = z.lazy(
  () => individualPaymentRenegotiationViewModelSchema,
) as unknown as ToZod<PostApiV1IndividualpaymentRenegotiationsPreview200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentRenegotiationsPreview401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentRenegotiationsPreview401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentRenegotiationsPreview500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentRenegotiationsPreview500>;

export const postApiV1IndividualpaymentRenegotiationsPreviewMutationRequestSchema =
  z.lazy(
    () => individualPaymentRenegotiationViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentRenegotiationsPreviewMutationRequest>;

export const postApiV1IndividualpaymentRenegotiationsPreviewMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentRenegotiationsPreview200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentRenegotiationsPreviewMutationResponse>;
